import { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  useMetierTypes,
  useMetiers,
  useCreateMetierType,
  useUpdateMetierType,
  useDeleteMetierType,
  useCreateMetier,
  useUpdateMetier,
  useDeleteMetier,
} from "../../../hooks/useMetiers";
import {
  Container,
  Form,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col,
  Nav,
  NavItem,
  TabPane,
  TabContent,
  NavLink,
  FormFeedback,
} from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../../Components/Common/DeleteModal";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TableContainer from "../../../Components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useCallback } from "react";
import classnames from "classnames";

import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
// import { red } from "@material-ui/core/colors";

const JobsPage = (props) => {
  const sanitizeText = (value) => String(value || "").trim();
  const [selectedMetier, setSelectedMetier] = useState(null);
  const [deleteTargetKind, setDeleteTargetKind] = useState("metier");
  const [isEdit, setIsEdit] = useState(false);
  const [isMet, setMet] = useState({});
  const { data: metierTypeListQ } = useMetierTypes();
  const { data: metiersQ } = useMetiers();
  const createMetierType = useCreateMetierType();
  const updateMetierType = useUpdateMetierType();
  const deleteMetierType = useDeleteMetierType();
  const createMetier = useCreateMetier();
  const updateMetier = useUpdateMetier();
  const deleteMetier = useDeleteMetier();

  // The query results are read directly rather than mirrored into state. A
  // `useState` + `useEffect` copy of them looped forever: destructuring with a
  // `= []` default builds a new array on every render where `data` is still
  // undefined, so the effect's dependency changed identity each time, setting
  // state and triggering the next render. Memoised fallbacks keep a stable
  // identity for the empty case.
  const EMPTY = useMemo(() => [], []);
  const metierList = metierTypeListQ ?? EMPTY;
  const metier = metiersQ ?? EMPTY;

  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [type, setType] = useState({});
  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setType({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggle2 = useCallback(() => {
    if (modal2) {
      setModal2(false);
    } else {
      setModal2(true);
    }
  }, [modal2]);

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (metierItem, kind = "metier") => {
    setSelectedMetier(metierItem);
    setDeleteTargetKind(kind);
    setDeleteModal(true);
  };

  const handleDeleteCategory = () => {
    if (selectedMetier && selectedMetier.id) {
      const mutation =
        deleteTargetKind === "type" ? deleteMetierType : deleteMetier;

      mutation.mutate(selectedMetier.id, {
        onSuccess: () => {
          toast.success(
            deleteTargetKind === "type"
              ? "Type de métier supprimé avec succès"
              : "Métier supprimé avec succès",
            { autoClose: 3000 }
          );
          setDeleteModal(false);
        },
        onError: () => {
          toast.error(
            deleteTargetKind === "type"
              ? "Une erreur est survenue lors de la suppression du type de métier"
              : "Une erreur est survenue lors de la suppression du métier",
            { autoClose: 3000 }
          );
          setDeleteModal(false);
        },
      });
    }
  };

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate an asynchronous operation (e.g., fetching data)
    setTimeout(() => {
      setIsLoading(false); // Set loading to false once the data is fetched or loaded
    }, 2000); // Adjust the time according to your needs
  }, []);

  const [dele, setDele] = useState(0);
  // Displat Delete Button
  const displayDelete = () => {
    const ele = document.querySelectorAll(".entrepriseCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".entrepriseCheckBox:checked");
    const del = document.getElementById("selection-element");
    const ids = Array.from(ele).map((e) => e.value);
    ids.forEach((id) => deleteMetier.mutate(id));
    del.style.display = "none";
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      label: (type && type.label) || " ",
    },

    validationSchema: Yup.object().shape({
      label: Yup.string().required(props.t("Entrer un metier")),
    }),

    onSubmit: (values) => {
      if (!isEdit) {
        const newCategory = {
          label: values.label,
        };

        let count = 0;
        if (newCategory) {
          for (let i = 0; i <= metierList.length; i++) {
            if (newCategory.label === metierList[i]?.label) {
              count = count + 1;
              toast.error(props.t("Le métier existe deja"), {
                autoClose: 3000,
              });
              break;
            }
          }
          if (count === 0) {
            createMetierType.mutate(newCategory, {
              onSuccess: () =>
                toast.success(props.t("Métier bien ajouté"), {
                  autoClose: 3000,
                }),
              onError: () =>
                toast.error(props.t("Métier non ajouté"), { autoClose: 3000 }),
            });
            validation.resetForm();
            setModal(false);
          } else {
            count = 0;
          }
        }
      } else {
        const updateCategory = {
          id: type && type.id,
          label: values.label,
        };

        let count = 0;
        if (updateCategory) {
          for (let i = 0; i <= metierList.length; i++) {
            if (updateCategory.label === metierList[i]?.label) {
              count = count + 1;
              toast.error(props.t("Le métier existe deja"), {
                autoClose: 3000,
              });
              break;
            }
          }
          if (count === 0) {
            updateMetierType.mutate(
              { id: updateCategory.id, payload: updateCategory },
              {
                onSuccess: () =>
                  toast.success(props.t("Type de métier bien modifié"), {
                    autoClose: 3000,
                  }),
                onError: () =>
                  toast.error(props.t("Type de métier non modifié"), {
                    autoClose: 3000,
                  }),
              }
            );
            validation.resetForm();
            setModal(false);
          } else {
            count = 0;
          }
        }
      }
    },
  });

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      metier_type_id: isMet?.metier_type_id ? String(isMet.metier_type_id) : "",
      label: isMet?.label || "",
    },

    validationSchema: Yup.object().shape({
      metier_type_id: Yup.number()
        .typeError(props.t("Sélectionnez un type de métier"))
        .required(props.t("Sélectionnez un type de métier")),
      label: Yup.string()
        .transform((value) => (typeof value === "string" ? value.trim() : value))
        .required(props.t("Entrer un metier")),
    }),

    onSubmit: (values) => {
      const trimmedLabel = sanitizeText(values.label);
      const metierTypeId = Number(values.metier_type_id);
      if (!trimmedLabel) {
        toast.error(props.t("Entrer un metier"), { autoClose: 3000 });
        return;
      }
      if (!Number.isInteger(metierTypeId) || metierTypeId <= 0) {
        toast.error(props.t("Sélectionnez un type de métier"), {
          autoClose: 3000,
        });
        return;
      }

      if (!isEdit) {
        const newCategory = {
          metier_type_id: metierTypeId,
          label: trimmedLabel,
        };
        createMetier.mutate(newCategory, {
          onSuccess: () =>
            toast.success(props.t("Métier bien ajouté"), { autoClose: 3000 }),
          onError: () =>
            toast.error(props.t("Métier non ajouté"), { autoClose: 3000 }),
        });
        validation2.resetForm();
        setModal2(false);
      } else {
        const newCategory = {
          id: isMet && isMet.id,
          metier_type_id: metierTypeId,
          label: trimmedLabel,
        };
        updateMetier.mutate(
          { id: newCategory.id, payload: newCategory },
          {
            onSuccess: () =>
              toast.success(props.t("Métier bien modifié"), {
                autoClose: 3000,
              }),
            onError: () =>
              toast.error(props.t("Métier non modifié"), { autoClose: 3000 }),
          }
        );
        validation2.resetForm();
        setModal2(false);
      }
    },
  });

  const handleContactClick = useCallback(
    (arg) => {
      setType({
        id: arg.id,
        label: arg.label,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const handleContactClicks = useCallback(
    (arg) => {
      setMet({
        id: arg.id,
        metier_type_id: arg.metier_type?.id || "",
        label: arg.label,
      });

      setIsEdit(true);
      toggle2();
    },
    [toggle2]
  );

  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };
  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("TITRE"),
        accessor: "label",
        Cell: (metiers) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  <Link to="/jobs" className="text-dark">
                    {" "}
                    {metiers.row.original.label}
                  </Link>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTION",
        Cell: (cellProps) => {
          const metiersData = cellProps.row.original;
          return (
            <ul className="list-inline mb-0">
              <li className="list-inline-item" title={props.t("Modifier")}>
                <button
                  type="button"
                  className="btn btn-link p-0 text-warning d-inline-block"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleContactClick(metiersData);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </button>
              </li>
              <li className="list-inline-item" title={props.t("Supprimer")}>
                <button
                  type="button"
                  className="btn btn-link p-0 text-danger d-inline-block"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onClickDelete(metiersData, "type");
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom"></i>
                </button>
              </li>
            </ul>
          );
        },
      },
    ],
    [props, handleContactClick]
  );

  const columns1 = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("TYPE METIER"),
        Cell: (metiers) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  <Link to="/jobs" className="text-dark">
                    {" "}
                    {metiers.row.original.metier_type &&
                      metiers.row.original.metier_type?.label}
                  </Link>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TITRE"),
        Cell: (metiers) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  <Link to="/jobs" className="text-dark">
                    {" "}
                    {metiers.row.original.label}
                  </Link>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const metiersData = cellProps.row.original;
          return (
            <ul className="list-inline mb-0">
              <li className="list-inline-item" title={props.t("Modifier")}>
                <button
                  type="button"
                  className="btn btn-link p-0 text-warning d-inline-block"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleContactClicks(metiersData);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </button>
              </li>
              <li className="list-inline-item" title={props.t("Supprimer")}>
                <button
                  type="button"
                  className="btn btn-link p-0 text-danger d-inline-block"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    onClickDelete(metiersData, "metier");
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom"></i>
                </button>
              </li>
            </ul>
          );
        },
      },
    ],
    [props, handleContactClicks]
  );

  document.title = props.t("Liste des métiers");

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteCategory}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title={props.t("Métiers")} pageTitle={props.t("Métiers")} />

        <Nav tabs className="nav-tabs-custom nav-success">
          <NavItem>
            <NavLink
              style={{ cursor: "pointer", fontWeight: "bold" }}
              className={classnames({
                active: customActiveTab === "1",
              })}
              onClick={() => {
                toggleCustom("1");
              }}
            >
              {props.t("TYPE DE METIER")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer", fontWeight: "bold" }}
              className={classnames({
                active: customActiveTab === "2",
              })}
              onClick={() => {
                toggleCustom("2");
              }}
            >
              {props.t("METIER")}
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent
          activeTab={customActiveTab}
          className=" border-top-0 "
          id="nav-tabContent"
        >
          <TabPane id="nav-speci" tabId="1">
            <div>
              <Row>
                <div className="col-xl-12 col-lg-12">
                  <div>
                    <div className="card">
                      <div className="card-header border-0">
                        <Row className="g-4 align-items-center">
                          <div className="col-sm-auto ms-auto">
                            <div>
                              <button
                                className="btn btn-warning"
                                onClick={() => {
                                  setModal(true);
                                  setIsEdit(false);
                                }}
                              >
                                <i className="ri-add-fill align-bottom me-1"></i>{" "}
                                Ajouter un type de métier
                              </button>
                            </div>
                          </div>
                        </Row>
                        <div className="row align-items-center">
                          <div className="col-auto">
                            <div id="selection-element">
                              <div className="my-n1 d-flex align-items-center text-muted">
                                Select{" "}
                                <div
                                  id="select-content"
                                  className="text-body fw-semibold px-1"
                                >
                                  {dele}
                                </div>{" "}
                                Result{" "}
                                <button
                                  type="button"
                                  className="btn btn-link link-danger p-0 ms-3"
                                  onClick={() => setDeleteModalMulti(true)}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body pt-0">
                        <Modal
                          id="showModal1"
                          isOpen={modal}
                          toggle={toggle}
                          centered
                        >
                          <ModalHeader
                            className="bg-soft-info p-3"
                            toggle={toggle}
                          >
                            {!!isEdit
                              ? props.t("Modifier Type")
                              : props.t("Ajouter Type")}
                          </ModalHeader>

                          <Form
                            onSubmit={(e) => {
                              e.preventDefault();
                              validation.handleSubmit();
                              return false;
                            }}
                          >
                            <ModalBody>
                              <Input type="hidden" id="id-field" />
                              <Row className="g-3">
                                <Col lg={12}>
                                  <div>
                                    <Label htmlFor="" className="form-label">
                                      {props.t("Type")}
                                    </Label>
                                    <Input
                                      name="label"
                                      id="label"
                                      className="form-control"
                                      placeholder={props.t("Entrez le nom")}
                                      type="text"
                                      validate={{
                                        required: { value: true },
                                      }}
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.label || ""}
                                      invalid={
                                        validation.touched.label &&
                                        validation.errors.label
                                          ? true
                                          : false
                                      }
                                    />
                                    {validation.touched.label &&
                                    validation.errors.label ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.label}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                            </ModalBody>
                            <ModalFooter>
                              <div className="hstack gap-2 justify-content-end">
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  onClick={() => {
                                    setModal(false);
                                  }}
                                >
                                  {" "}
                                  {props.t("Fermer")}{" "}
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-warning"
                                  id="add-btn"
                                >
                                  {" "}
                                  {!!isEdit
                                    ? props.t("Modifier")
                                    : props.t("Ajouter")}{" "}
                                </button>
                              </div>
                            </ModalFooter>
                          </Form>
                        </Modal>
                        {isLoading ? ( // If loading, show loading indicator
                          <div className="py-4 text-center">
                            <div>
                              <lord-icon
                                src="https://cdn.lordicon.com/xjovhxra.json"
                                trigger="loop"
                                colors="primary:#0960b6,secondary:#02376b"
                                style={{ width: "72px", height: "72px" }}
                              ></lord-icon>
                            </div>
                            <div className="mt-4">
                              <h5>{props.t("Chargement")}...</h5>
                            </div>
                          </div>
                        ) : metierList && metierList.length >= 0 ? (
                          <TableContainer
                            columns={columns}
                            data={metierList || []}
                            isAddUserList={false}
                            customPageSize={10}
                            divClass="table-responsive mb-1"
                            tableClass="mb-0 align-middle table-borderless"
                            theadClass="table-light text-muted"
                            isMetierFilter={false}
                            isGlobalFilter={true}
                          />
                        ) : (
                          <div className="py-4 text-center">
                            <div className="mt-4">
                              <h5>
                                {" "}
                                {props.t(
                                  "Désolé, pas de resultats trouvés"
                                )}{" "}
                              </h5>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Row>
            </div>
          </TabPane>
        </TabContent>
        <TabContent
          activeTab={customActiveTab}
          className="border-top-0 "
          id="nav-tabContent"
        >
          <TabPane id="nav-speci" tabId="2">
            <div>
              <Row>
                <div className="col-xl-12 col-lg-12">
                  <div>
                    <div className="card">
                      <div className="card-header border-0">
                        <Row className="g-4 align-items-center">
                          <div className="col-sm-auto ms-auto">
                            <div>
                              <button
                                className="btn btn-warning"
                                onClick={() => {
                                  setModal2(true);
                                  setIsEdit(false);
                                }}
                              >
                                <i className="ri-add-fill align-bottom me-1"></i>{" "}
                                Ajouter un métier
                              </button>
                            </div>
                          </div>
                        </Row>
                        <div className="row align-items-center">
                          <div className="col-auto">
                            <div id="selection-element">
                              <div className="my-n1 d-flex align-items-center text-muted">
                                Select{" "}
                                <div
                                  id="select-content"
                                  className="text-body fw-semibold px-1"
                                >
                                  {dele}
                                </div>{" "}
                                Result{" "}
                                <button
                                  type="button"
                                  className="btn btn-link link-danger p-0 ms-3"
                                  onClick={() => setDeleteModalMulti(true)}
                                >
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body pt-0">
                        <Modal
                          id="showModal1"
                          isOpen={modal2}
                          toggle={toggle2}
                          centered
                        >
                          <ModalHeader
                            className="bg-soft-info p-3"
                            toggle={toggle2}
                          >
                            {!!isEdit
                              ? props.t("Modifier Type")
                              : props.t("Ajouter Type")}
                          </ModalHeader>

                          <Form
                            onSubmit={(e) => {
                              e.preventDefault();
                              validation2.handleSubmit();
                              return false;
                            }}
                          >
                            <ModalBody>
                              <Input type="hidden" id="id-field" />
                              <Row className="g-3">
                                <Col lg={12}>
                                  <div>
                                    <Label htmlFor="" className="form-label">
                                      {props.t("Type")}
                                    </Label>
                                    <Input
                                      name="metier_type_id"
                                      className="form-control"
                                      type="select"
                                      validate={{
                                        required: { value: true },
                                      }}
                                      onChange={validation2.handleChange}
                                      onBlur={validation2.handleBlur}
                                      value={validation2.values.metier_type_id || ""}
                                      invalid={
                                        validation2.touched.metier_type_id &&
                                        validation2.errors.metier_type_id
                                          ? true
                                          : false
                                      }
                                    >
                                      <option className="form-select" value="">
                                        Sélectionner un domaine
                                      </option>
                                      {metierList &&
                                        metierList.map((item, key) => (
                                          <option value={item.id} key={key}>
                                            {item.label}
                                          </option>
                                        ))}
                                    </Input>
                                    {validation2.touched.metier_type_id &&
                                    validation2.errors.metier_type_id ? (
                                      <FormFeedback type="invalid">
                                        {validation2.errors.metier_type_id}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                                <Col lg={12}>
                                  <div>
                                    <Label htmlFor="" className="form-label">
                                      {props.t("Désignation")}
                                    </Label>
                                    <Input
                                      name="label"
                                      id="label"
                                      className="form-control"
                                      type="text"
                                      validate={{
                                        required: { value: true },
                                      }}
                                      onChange={validation2.handleChange}
                                      onBlur={validation2.handleBlur}
                                      value={validation2.values.label || ""}
                                      invalid={
                                        validation2.touched.label &&
                                        validation2.errors.label
                                          ? true
                                          : false
                                      }
                                    />
                                    {validation2.touched.label &&
                                    validation2.errors.label ? (
                                      <FormFeedback type="invalid">
                                        {validation2.errors.label}
                                      </FormFeedback>
                                    ) : null}
                                  </div>
                                </Col>
                              </Row>
                            </ModalBody>
                            <ModalFooter>
                              <div className="hstack gap-2 justify-content-end">
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  onClick={() => {
                                    setModal2(false);
                                  }}
                                >
                                  {" "}
                                  {props.t("Fermer")}{" "}
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-warning"
                                  id="add-btn"
                                >
                                  {" "}
                                  {!!isEdit
                                    ? props.t("Modifier")
                                    : props.t("Ajouter")}{" "}
                                </button>
                              </div>
                            </ModalFooter>
                          </Form>
                        </Modal>
                        <ToastContainer closeButton={false} />
                        {isLoading ? ( // If loading, show loading indicator
                          <div className="py-4 text-center">
                            <div>
                              <lord-icon
                                src="https://cdn.lordicon.com/xjovhxra.json"
                                trigger="loop"
                                colors="primary:#0960b6,secondary:#02376b"
                                style={{ width: "72px", height: "72px" }}
                              ></lord-icon>
                            </div>
                            <div className="mt-4">
                              <h5>{props.t("Chargement")}...</h5>
                            </div>
                          </div>
                        ) : metier && metier.length >= 0 ? (
                          <TableContainer
                            columns={columns1}
                            data={metier || []}
                            isAddUserList={false}
                            customPageSize={10}
                            divClass="table-responsive mb-1"
                            tableClass="mb-0 align-middle"
                            theadClass="table-light text-muted"
                            isMetierFilter={false}
                            isGlobalFilter={true}
                          />
                        ) : (
                          <div className="py-4 text-center">
                            <div className="mt-4">
                              <h5>
                                {" "}
                                {props.t(
                                  "Désolé, pas de resultats trouvés"
                                )}{" "}
                              </h5>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Row>
            </div>
          </TabPane>
        </TabContent>
      </Container>
    </div>
  );
};
JobsPage.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(JobsPage));
